import { render, staticRenderFns } from "./SurveyNavigation.vue?vue&type=template&id=51b4574e&scoped=true&"
import script from "./SurveyNavigation.vue?vue&type=script&lang=js&"
export * from "./SurveyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SurveyNavigation.vue?vue&type=style&index=0&id=51b4574e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4574e",
  null
  
)

export default component.exports